import { render, staticRenderFns } from "./WapCZCX01CustomerSignNumber.vue?vue&type=template&id=b7d4b1e6&scoped=true&"
import script from "./WapCZCX01CustomerSignNumber.vue?vue&type=script&lang=js&"
export * from "./WapCZCX01CustomerSignNumber.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7d4b1e6",
  null
  
)

export default component.exports